import styled from '@mui/material/styles/styled';

export const BaseDrawerLoaderWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;
